import { render, staticRenderFns } from "./ApplicantList.vue?vue&type=template&id=141c5512"
import script from "./ApplicantList.vue?vue&type=script&lang=js"
export * from "./ApplicantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports